import React from "react";
import { EditToggle } from "..";
import { Close } from "assets/icons";
import ButtonNew from "components/buttonNew/buttonNew";

interface SectionHeaderProps {
  title: string;
  icon?: any;
  type?: "edit" | "action";
  action?: any;
  sticky?: boolean;
  editMode?: boolean;
  onEditClick?: any;
  onSaveClick?: any;
  showEditToggle?: boolean;
  hasUnsavedChanges?: boolean;
  onCloseClick?: () => any;
  hideCloseAction?: boolean;
}

export const SectionHeader = ({
  title,
  icon = "",
  type = "edit",
  action = null,
  sticky = true,
  editMode = false,
  onEditClick = null,
  onSaveClick = null,
  showEditToggle = true, //
  hasUnsavedChanges = false,
  onCloseClick,
  hideCloseAction = false,
}: SectionHeaderProps) => (
  <div
    className={`${
      sticky
        ? "sticky top-16 z-30 backdrop-blur-lg sm:static sm:top-0"
        : "status"
    } flex items-center justify-between gap-2 rounded-md bg-linear-to-b from-white/80 to-white/1 px-2.5 py-2.5`}
  >
    <div className="flex flex-row items-center gap-1.5">
      {icon && React.cloneElement(icon, { className: "h-[18px] w-[18px]" })}
      <p className="text-lg">{title}</p>
    </div>
    <div className="flex-end flex items-center gap-4">
      {hasUnsavedChanges && (
        <div className="text-red-500">
          Er zijn wijzigingen, vergeet niet op te slaan!
        </div>
      )}
      {type === "edit" && showEditToggle ? (
        <EditToggle
          editMode={editMode}
          onEditClick={onEditClick}
          onSaveClick={onSaveClick}
        />
      ) : (
        action
      )}
      {onCloseClick && !hideCloseAction && (
        <ButtonNew
          variant="secondaryNeutral"
          icon={<Close />}
          onClick={onCloseClick}
          label="Sluiten"
        />
      )}
    </div>
  </div>
);
